import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import WarningIcon from "@mui/icons-material/Warning";

export default function DowntimeBanner() {
  const startDate = new Date("2026-03-01T10:00:00+01:00").getTime();
  const endDate = new Date("2026-03-10T15:00:00+01:00").getTime();
  const { t } = useTranslation();

  const [visible, setVisible] = useState(
    Date.now() >= startDate && Date.now() <= endDate
  );

  useEffect(() => {
    const timeout = endDate - Date.now();
    if (timeout <= 0) return;

    const timer = setTimeout(() => setVisible(false), timeout);
    return () => clearTimeout(timer);
  }, [endDate]);

  if (!visible) return null;

  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "warning.main",
        color: "#ffffff",
        textAlign: "center",
        py: 1,
        px: 2,
        position: "sticky",
        top: 0,
        zIndex: 1300,
        marginBottom: 2,
      }}
    >
      <Typography
        variant="body1"
        fontWeight={500}
        sx={{
          display: "flex",
          alignItems: "center",
          textAlign: "center",
          justifyContent: "center",
          gap: 2,
        }}
      >
        <WarningIcon
          sx={{
            width: "24px",
            height: "24px",
          }}
        />
        {t("tts.downtimeBanner")}
      </Typography>
    </Box>
  );
}
